module.exports = __webpack_public_path__ + "static/media/lullascape-2.6a5f7602.jpg";